import {
  SidenavbarCom,
  MultiplayCheckBoxSelection,
  Dropdown,
  InputField,
  HoverButton,
  Jobtable,
  SearchbarCom,
  Pagination,
} from "../../components";
import Icons from "../../assets/icon";
import { IoIosArrowRoundBack } from "react-icons/io";
import { HiDotsHorizontal } from "react-icons/hi";
import Functions from "./index.function.js";
export default function AppliedJobs() {
  const {
    control,
    dropdownLoading,
    isLoadingStates,
    citiesisLoading,
    handleInput,
    getValues,
    setValue,
    setFilterPopup,
    filterPopup,
    jobsData,
    appliedJobData,
    activeTab,
    setActiveTab,
    isLoading,
    appliedJobsisLoading,
    currentPage,
    setCurrentPage,
    total_pages,
    has_more_pages,
    total_pagesapplied,
    has_more_pagesapplied,
    selectedExperience,
    index,
    rangeRef,
    tooltipPos,
    experiences,
    isFreelance,
    toggleFreelance,
    select,
    showPopup,
    handleDropdwonSelect,
    states,
    cities,
    dropdowns,
    jobDropdowns,
    errors,
    register,
    handleSubmit,
    onSubmit,
    resetFilters,
    valuejobslisting,
    setValueJobslisting,
    loadingapi,
    loadingapplyapi,
    handleSevedJob,
    handleApplyJob,
    userData,
    loading,
    handleStartChat,
    formatDate,
    setAppliedCurrentPage,
    appliedCurrentPage,
    setShowPopup,
  } = Functions();
  return (
    <div className="h-screen w-screen flex flex-col bg-[#000000]">
      {/* Navbar */}
      <SearchbarCom />
      <div className="grid sm:grid-cols-7 lg:grid-cols-6 xs:pt-10 sm:pt-16 sm:px-2 lg:px-2 xl:px-3">
        {/* Left Sidebar */}
        <div className="sm:col-span-2 lg:col-span-1 xs:z-50">
          <SidenavbarCom />
        </div>

        {/* Center Content (Scrollable) */}
        <div className=" sm:col-span-5 overflow-hidden h-[calc(100vh-4rem)]">
          <div className={` w-full xs:px-1 sm:pl-4 lg:pl-5 h-full pt-2 pb-1`}>
            <div className="flex flex-col relative w-full h-full bg-[#1A1A1A] xs:px-2 sm:px-3 lg:px-5 rounded-lg">
              <div className="flex items-center justify-between py-5 sm:py-10">
                <h1 className="text-white xs:text-xs sm:text-sm lg:text-4xl font-onestSemiBold">
                  Job List
                </h1>
                <div className="flex justify-start items-center gap-3">
                  <div
                    className="bg-[#2A2A2A] p-1 sm:p-3 rounded-full"
                    onClick={() => {
                      setFilterPopup(true);
                      setShowPopup(false);
                    }}
                  >
                    <img
                      src={Icons.filtersIcons}
                      className="xs:w-4 xs:h-4 sm:w-6 sm:h-6 lg:w-7 lg:h-7"
                      alt="filters Icons"
                    />
                  </div>
                  <div className="flex items-center bg-[#2A2A2A] xs:gap-x-1 gap-x-2 p-1 rounded-full">
                    <button
                      onClick={() => setActiveTab("active-jobs")}
                      type={"button"}
                      className={`group xs:w-20 xs:h-8 sm:w-28 sm:h-10 lg:w-36 ${
                        activeTab === "active-jobs"
                          ? `gradient-container_btn`
                          : ""
                      } xl:w-40 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Active Jobs
                      </p>
                    </button>
                    <button
                      onClick={() => setActiveTab("applied-jobs")}
                      type={"button"}
                      className={`group xs:w-20 xs:h-8 sm:w-28 sm:h-10 lg:w-36 ${
                        activeTab === "applied-jobs"
                          ? `gradient-container_btn`
                          : ""
                      } xl:w-40 cursor-pointer bg-cover flex lg:h-10 text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform hover:shadow-lg`}
                    >
                      <p
                        className={`text-secondary font-onestRegular xs:text-[10px] sm:text-xs lg:text-sm xl:text-base `}
                      >
                        Applied Jobs
                      </p>
                    </button>
                  </div>
                </div>
              </div>
              {activeTab === "active-jobs" && (
                <Jobtable
                  title={[
                    "Job Title",
                    "Jobs Type",
                    "Country",
                    "Province",
                    "City",
                    "Description",
                    "Benefits",
                    "Expiry Date",
                    "Salary",
                    "NO Of Positions",
                    "Actions",
                  ]}
                  // title={['Job Title', 'Jobs Type', 'Country', 'Province', 'City', 'Post Code', 'Description', 'Benefits', 'Job Shift', 'Gender', 'Expiry Date', 'Degree Level', 'Salary', 'NO Of Positions', 'Actions']}
                  data={jobsData?.jobs}
                  setValueJobslisting={setValueJobslisting}
                  setShowPopup={setShowPopup}
                  setFilterPopup={setFilterPopup}
                  loadingapi={loadingapi}
                  loadingapplyapi={loadingapplyapi}
                  handleApplyJob={handleApplyJob}
                  isLoading={isLoading}
                  handleSevedJob={handleSevedJob}
                  formatDate={formatDate}
                  requestTitle={"Active Jobs"}
                />
              )}

              {activeTab === "applied-jobs" && (
                <Jobtable
                  title={[
                    "Job Title",
                    "Jobs Type",
                    "Country",
                    "Province",
                    "City",
                    "Description",
                    "Benefits",
                    "Expiry Date",
                    "Salary",
                    "NO Of Positions",
                    "Status",
                  ]}
                  // title={['Job Title', 'Jobs Type', 'Country', 'Province', 'City', 'Post Code', 'Description', 'Benefits', 'Job Shift', 'Gender', 'Expiry Date', 'Degree Level', 'Salary', 'NO Of Positions', 'Actions']}
                  data={appliedJobData?.job_applies}
                  formatDate={formatDate}
                  requestTitle={"Applied Jobs"}
                  setShowPopup={setShowPopup}
                  setFilterPopup={setFilterPopup}
                  handleStartChat={handleStartChat}
                  setValueJobslisting={setValueJobslisting}
                  appliedJobsisLoading={appliedJobsisLoading}
                  loading={loading}
                />
              )}
              <div className="pt-2.5 pb-5 sm:pt-5 sm:pb-10">
                {activeTab === "active-jobs" &&
                  jobsData?.total_records > 10 && (
                    <div className="flex justify-end items-center">
                      <Pagination
                        setCurrentPage={setCurrentPage}
                        currentPage={currentPage}
                        total_pages={total_pages}
                        has_more_pages={has_more_pages}
                      />
                    </div>
                  )}
                {activeTab === "applied-jobs" && (
                  <>
                    {appliedJobData?.total_records > 10 && (
                      <div className="flex justify-end items-center pt-5">
                        <Pagination
                          setCurrentPage={setAppliedCurrentPage}
                          currentPage={appliedCurrentPage}
                          total_pages={total_pagesapplied}
                          has_more_pages={has_more_pagesapplied}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* Popup Modal */}
              <div
                className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-2 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-full scroll-container ${
                  showPopup ? "translate-x-0" : "translate-x-full"
                } transition-transform duration-300 ease-in-out`}
              >
                <div className="flex justify-center items-start flex-col relative w-full h-full">
                  <div
                    className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                    onClick={() => setShowPopup(false)}
                  >
                    <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                    <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                      Back
                    </p>
                  </div>
                  <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
                    <h2 className="text-secondary  font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-2xl">
                      JOB DESCRIPTION
                    </h2>
                  </div>
                  <div className="w-full flex-1 overflow-y-auto dashboard-scrollbar sm:pr-2 pr-1">
                    {valuejobslisting?.job ? (
                      <>
                        <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                              Job Title:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.title}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Jobs Type:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.job_types?.job_type}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Country:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.country?.country}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Province:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.state?.state}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              City:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.city?.city}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Post code:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.postal_code}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                          <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Description
                            </p>
                          </div>
                          <div className="xs:max-h-[120px] sm:max-h-[150px] custom-scrollbar overflow-y-scroll">
                            <p
                              className="html-container font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm"
                              dangerouslySetInnerHTML={{
                                __html: valuejobslisting?.job?.description,
                              }}
                            />
                          </div>
                        </div>
                        <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                          <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Benefits
                            </p>
                          </div>
                          <div className="xs:gap-x-2 xs:gap-y-2 sm:gap-x-3 sm:gap-y-3 flex items-center flex-wrap">
                            <div className="xs:max-h-[120px] bg-[#2A2A2A] xs:px-3 xs:py-1 sm:px-3 sm:py-1 xs:rounded-md sm:rounded-lg sm:max-h-[150px] custom-scrollbar overflow-y-scroll">
                              <p
                                className="html-container  text-secondary xs:text-xs sm:text-sm lg:text-base"
                                dangerouslySetInnerHTML={{
                                  __html: valuejobslisting?.job?.benefits,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                              Job Shift:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.job_shift?.job_shift}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Gender:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.gender?.gender}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                              Expiry Date:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {formatDate(valuejobslisting?.job?.expiry_date)}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Degree Level:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {
                                  valuejobslisting?.job?.degree_level
                                    ?.degree_level
                                }
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          {valuejobslisting?.job?.hide_salary ? (
                            ""
                          ) : (
                            <div>
                              <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                                Salary:
                                <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                  {valuejobslisting?.job?.salary_currency ?? ""}{" "}
                                  {valuejobslisting?.job?.salary_from} -{" "}
                                  {valuejobslisting?.job?.salary_to}
                                </span>
                              </p>
                            </div>
                          )}
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              No of Positions:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job?.num_of_positions}
                              </span>
                            </p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                              Job Title:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.title}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Jobs Type:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job_types?.job_type}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Country:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.country?.country}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Province:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.state?.state}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex justify-between xs:py-2 sm:py-3 lg:py-4">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              City:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.city?.city}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Post code:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.postal_code}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                          <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Description
                            </p>
                          </div>
                          <div className="xs:max-h-[120px] sm:max-h-[150px] custom-scrollbar overflow-y-scroll">
                            <p
                              className="html-container font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm"
                              dangerouslySetInnerHTML={{
                                __html: valuejobslisting?.description,
                              }}
                            />
                          </div>
                        </div>
                        <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                          <div className="xs:pb-2 sm:pb-3 lg:pb-4">
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Benefits
                            </p>
                          </div>
                          <div className="xs:gap-x-2 xs:gap-y-2 sm:gap-x-3 sm:gap-y-3 flex items-center flex-wrap">
                            <div className="xs:max-h-[120px] bg-[#2A2A2A] xs:px-3 xs:py-1 sm:px-3 sm:py-1 xs:rounded-md sm:rounded-lg sm:max-h-[150px] custom-scrollbar overflow-y-scroll">
                              <p
                                className="html-container  text-secondary xs:text-xs sm:text-sm lg:text-base"
                                dangerouslySetInnerHTML={{
                                  __html: valuejobslisting?.benefits,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                              Job Shift:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.job_shift?.job_shift}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Gender:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.gender?.gender}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                              Expiry Date:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {formatDate(valuejobslisting?.expiry_date)}
                              </span>
                            </p>
                          </div>
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              Degree Level:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.degree_level?.degree_level}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div className="flex xs:py-2 sm:py-3 lg:py-4 justify-between">
                          {valuejobslisting?.hide_salary ? (
                            ""
                          ) : (
                            <div>
                              <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary lg:gap-x-4">
                                Salary:
                                <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                  {valuejobslisting?.salary_currency ?? ""}{" "}
                                  {valuejobslisting?.salary_from} -{" "}
                                  {valuejobslisting?.salary_to}
                                </span>
                              </p>
                            </div>
                          )}
                          <div>
                            <p className="xs:text-[10px] sm:text-sm lg:text-base font-onestRegular text-secondary">
                              No of Positions:
                              <span className="xs:ml-1 sm:ml-1.5 lg:ml-2 xl:ml-3 font-onestRegular text-[#8A8A8A] xs:!text-[8px] sm:text-xs lg:text-sm">
                                {valuejobslisting?.num_of_positions}
                              </span>
                            </p>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                  <div className=" xs:text-[8px] sm:text-xs lg:text-sm xl:text-base flex xs:pt-1 sm:pt-2 lg:pt-3 w-full justify-center">
                    {valuejobslisting?.status ? (
                      <>
                        {valuejobslisting?.status === "Accepted" && (
                          <HoverButton
                            extraClasses={`group w-full xs:h-10  sm:h-10 bg-cover flex text-secondary font-onestMedium items-center justify-center rounded-full transition-transform transform ${
                              loading
                                ? ""
                                : "cursor-pointer hover:scale-105 hover:shadow-md"
                            } `}
                            BtnTitle={
                              loading ? (
                                <div className="flex justify-center items-center">
                                  <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary h-12 w-12 lg:w-10 lg:h-10  md:w-8 md:h-8 sm:w-10 sm:h-10 xs:w-8 xs:h-8"></div>
                                </div>
                              ) : (
                                "Chat"
                              )
                            }
                            disabled={loading}
                            onClick={() => {
                              handleStartChat(
                                valuejobslisting?.job?.company?.user_id,
                                userData?.talent?.user_id
                              );
                            }}
                            type={"button"}
                            BtnTitleClasses={`text-secondary font-onestSemiBold sm:text-sm lg:text-lg transition-transform transform ${
                              loading
                                ? ""
                                : "group-hover:scale-110 group-hover:text-primary"
                            } `}
                          />
                        )}
                      </>
                    ) : (
                      <div className="xs:gap-1 sm:gap-2 lg:gap-3 flex justify-center items-center w-full">
                        <button
                          className={`bg-accepted xs:py-1 w-full flex justify-center xs:px-6 sm:px-8 sm:py-1 lg:px-10 lg:py-1 rounded-full ${
                            valuejobslisting?.is_job_applied
                              ? "cursor-not-allowed !opacity-55"
                              : "cursor-pointer"
                          }`}
                          onClick={() => {
                            handleApplyJob(
                              valuejobslisting?.id,
                              userData?.talent?.id
                            );
                          }}
                          disabled={valuejobslisting?.is_job_applied}
                          type="submit"
                        >
                          {loadingapplyapi ? (
                            <div className="flex justify-center items-center">
                              <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary w-6 h-6"></div>
                            </div>
                          ) : (
                            <p className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base font-onestRegular text-secondary">
                              {valuejobslisting?.is_job_applied
                                ? "Applied"
                                : "Apply"}
                            </p>
                          )}
                        </button>
                        <div
                          className="flex justify-center items-center rounded-full cursor-pointer xs:w-6 bg-[#787878] xs:h-5 sm:w-7 sm:h-6 lg:w-9 lg:h-8"
                          onClick={() => {
                            handleSevedJob(
                              valuejobslisting?.id,
                              valuejobslisting?.is_job_saved
                            );
                          }}
                        >
                          {loadingapi === valuejobslisting?.id ? (
                            <div className="animate-spin rounded-full border-t-2 border-b-2 border-secondary w-6 h-6"></div>
                          ) : valuejobslisting?.is_job_saved ? (
                            <img
                              src={Icons.dasSavedIcon}
                              className="xs:w-3.5 xs:h-3.5 sm:w-4 sm:h-4 lg:w-5 lg:h-5"
                              alt="MdOutlineStar"
                            />
                          ) : (
                            <img
                              src={Icons.dasSaveIcon}
                              className="xs:w-2.5 xs:h-2.5 sm:w-3 sm:h-3 lg:w-4 lg:h-4"
                              alt="MdOutlineStarBorder"
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div
                className={`fixed top-0 right-0 z-50 w-full sm:w-9/12 lg:w-7/12 xl:w-1/3 bg-[#0F0F0F] xs:py-3 xs:px-4 sm:px-3 sm:py-4 lg:px-4 lg:py-5 h-screen transition-transform duration-300 ease-in-out ${
                  filterPopup ? "translate-x-0" : "translate-x-full"
                }`}
              >
                <form
                  className="flex flex-col h-full w-full"
                  onSubmit={handleSubmit(onSubmit)}
                >
                  {/* Header */}
                  <div className="w-full">
                    <div
                      className={`group flex cursor-pointer justify-center items-center xs:px-1.5 sm:px-3 w-fit lg:px-5 xs:py-[1.5px] sm:py-1 bg-[#2A2A2A] xs:rounded-md sm:rounded-lg transition-transform duration-300 transform hover:scale-105`}
                      onClick={() => setFilterPopup(false)}
                    >
                      <IoIosArrowRoundBack className="text-secondary sm:text-2xl transition-colors duration-300 group-hover:text-orangeCrayola" />
                      <p className="text-secondary font-onestRegular xs:text-xs sm:text-sm lg:text-sm transition-colors duration-300 group-hover:text-secondary">
                        Back
                      </p>
                    </div>
                    <div className="text-center w-full xs:pt-4 xs:pb-5 sm:pt-7 sm:pb-7 lg:pb-10">
                      <h2 className="text-secondary font-unboundedBold uppercase xs:text-xs sm:text-lg lg:text-xl xl:text-4xl">
                        Job Filter
                      </h2>
                    </div>
                  </div>

                  {/* Scrollable Form Section */}
                  <div className="flex-1 overflow-y-auto dashboard-scrollbar  sm:pr-2 pr-1">
                    <div className="flex flex-col justify-start items-center w-full gap-4">
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                          <Dropdown
                            control={control}
                            label={"Country"}
                            options={dropdowns?.country}
                            valueName="country"
                            valueoption="country_id"
                            name={"countries"}
                            rightIcon={Icons.arrowIcon}
                            selectedValue={select.country}
                            handleSelect={(value) =>
                              handleDropdwonSelect("country", value)
                            }
                            errors={errors}
                            isRequired={true}
                            isLoading={dropdownLoading}
                          />
                        </div>
                        <div className="relative xs:w-full sm:w-1/2 lg:w-1/2">
                          <Dropdown
                            control={control}
                            label={"Province / State"}
                            options={states}
                            name={"states"}
                            valueName="state"
                            valueoption="state_id"
                            rightIcon={Icons.arrowIcon}
                            selectedValue={select.states}
                            handleSelect={(value) =>
                              handleDropdwonSelect("states", value)
                            }
                            errors={errors}
                            isRequired={true}
                            isLoading={isLoadingStates}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"City"}
                            options={cities}
                            selectedValue={select?.city}
                            handleSelect={(value) =>
                              handleDropdwonSelect("city", value)
                            }
                            valueName="city"
                            valueoption="city_id"
                            name={"city"}
                            errors={errors}
                            isRequired={true}
                            isLoading={citiesisLoading}
                          />
                        </div>
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"Gender"}
                            options={dropdowns?.gender}
                            name={"gender"}
                            selectedValue={select.gender}
                            handleSelect={(value) =>
                              handleDropdwonSelect("gender", value)
                            }
                            valueName="gender"
                            valueoption="id"
                            isRequired={true}
                            isLoading={dropdownLoading}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <div className="sm:mb-2 lg:mb-2 flex justify-start items-center">
                            <label className="xs:text-sm sm:text-base font-onestRegular text-secondary">
                              Job Shift
                            </label>
                          </div>
                          <MultiplayCheckBoxSelection
                            control={control}
                            name="job_shift"
                            items={"job_shift"}
                            mapitems={jobDropdowns?.job_shift}
                            // register={register}
                            errors={errors}
                            isRequired={false}
                            // label="job_shift"
                          />
                        </div>
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"Degree Level"}
                            options={jobDropdowns?.degree_level}
                            name={"degree_level"}
                            selectedValue={select?.degree_level}
                            handleSelect={(value) =>
                              handleDropdwonSelect("degree_level", value)
                            }
                            valueName="degree_level"
                            valueoption="degree_level_id"
                            errors={errors}
                            isRequired={true}
                            isLoading={dropdownLoading}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full">
                          <div className="w-full text-white">
                            <label className="block xs:text-sm sm:text-base font-onestRegular text-secondary mb-1">
                              Experience{" "}
                              <span className="text-xs font-onestRegular">
                                (years)
                              </span>
                            </label>
                            <div className="relative w-full mt-4">
                              {/* Tooltip */}
                              {selectedExperience !== null && (
                                <div
                                  // ref={tooltipRef}
                                  className="absolute -top-7 transform -translate-x-1/2 text-white text-xs font-semibold px-2 py-1 rounded whitespace-nowrap bg-goldMetallic"
                                  style={{ left: tooltipPos }}
                                >
                                  {selectedExperience}
                                  <div className="absolute left-1/2 top-full -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-l-transparent border-r-transparent border-t-goldMetallic" />
                                </div>
                              )}
                              {/* Slider */}
                              <input
                                ref={rangeRef}
                                type="range"
                                min="0"
                                max={experiences.length - 1}
                                value={index}
                                onChange={handleInput}
                                className="w-full h-2 bg-[#636363] rounded-lg appearance-none cursor-pointer
                                                                [&::-webkit-slider-thumb]:appearance-none
             [&::-webkit-slider-thumb]:w-4
             [&::-webkit-slider-thumb]:h-4
             [&::-webkit-slider-thumb]:rounded-full
             [&::-webkit-slider-thumb]:bg-yellow-400
             [&::-webkit-slider-thumb]:border-2
             [&::-webkit-slider-thumb]:border-white
             [&::-webkit-slider-thumb]:shadow-md
             [&::-moz-range-thumb]:appearance-none
             [&::-moz-range-thumb]:w-4
             [&::-moz-range-thumb]:h-4
             [&::-moz-range-thumb]:rounded-full
             [&::-moz-range-thumb]:bg-yellow-400
             [&::-moz-range-thumb]:border-2
             [&::-moz-range-thumb]:border-white
             [&::-moz-range-thumb]:shadow-md"
                                style={{
                                  background: `linear-gradient(to right, #D9A239 0%, #D9A239 ${
                                    (index / (experiences.length - 1)) * 100
                                  }%, #636363 ${
                                    (index / (experiences.length - 1)) * 100
                                  }%, #636363 100%)`,
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full">
                          <Dropdown
                            control={control}
                            rightIcon={Icons.arrowIcon}
                            label={"Salary Period"}
                            options={jobDropdowns?.salary_period}
                            name={"salary_period"}
                            selectedValue={select?.salary_period}
                            handleSelect={(value) =>
                              handleDropdwonSelect("salary_period", value)
                            }
                            valueName="salary_period"
                            valueoption="salary_period_id"
                            errors={errors}
                            isRequired={true}
                            isLoading={dropdownLoading}
                          />
                        </div>
                      </div>
                      <div
                        className={"flex xs:flex-col w-full sm:gap-2 lg:gap-4"}
                      >
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <InputField
                            control={control}
                            label="Salary From"
                            type="number"
                            name="salaryFrom"
                            {...register("salaryFrom", {
                              // required: 'Salary From is required',
                              validate: (value) => {
                                const to = getValues("salaryTo");
                                return (
                                  !to ||
                                  parseFloat(value) <= parseFloat(to) ||
                                  "Salary From must be less than or equal to Salary To"
                                );
                              },
                            })}
                            // errors={errors}
                            onChange={(value) => setValue("salaryFrom", value)}
                          />
                        </div>
                        <div className="relative mt-[18px] w-full sm:w-11/12">
                          <InputField
                            control={control}
                            label="Salary To"
                            type="number"
                            name="salaryTo"
                            {...register("salaryTo", {
                              // required: 'Salary To is required',
                              validate: (value) => {
                                const from = getValues("salaryFrom");
                                return (
                                  !from ||
                                  parseFloat(value) >= parseFloat(from) ||
                                  "Salary To must be greater than or equal to Salary From"
                                );
                              },
                            })}
                            // errors={errors}
                            onChange={(value) => setValue("salaryTo", value)}
                          />
                        </div>
                      </div>
                      <div className="flex justify-between items-center w-full py-3">
                        <div className=" flex justify-start items-center">
                          <label className="xs:text-sm sm:text-base font-onestRegular text-secondary">
                            Freelance
                          </label>
                        </div>
                        <div
                          onClick={toggleFreelance}
                          className={`w-16 h-8 xs:w-14 xs:h-6 sm:w-[60px] sm:h-7 rounded-full border-2 bg-primary border-goldMetallic relative cursor-pointer transition-all`}
                        >
                          <div
                            className={`w-6 h-6 xs:w-4 xs:h-4 sm:w-5 sm:h-5  text-white rounded-full absolute top-[2px] left-[2px] transition-transform duration-300 ${
                              isFreelance === 1
                                ? "transform translate-x-8 bg-goldMetallic"
                                : " bg-white"
                            }`}
                          ></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Footer Buttons */}
                  <div className="py-2 w-full">
                    <div
                      onClick={resetFilters}
                      className="w-full py-2 flex text-secondary justify-end items-center"
                    >
                      <p className="cursor-pointer hover:underline hover:text-orangeCrayola transition duration-200">
                        Reset Filters
                      </p>
                    </div>
                    <div className="xs:text-[8px] sm:text-xs lg:text-sm xl:text-base flex xs:pt-1 sm:pt-2 lg:pt-3 w-full justify-center">
                      <div className="xs:gap-1 sm:gap-2 lg:gap-3 flex justify-center items-center w-full">
                        <button
                          className="bg-accepted xs:py-2 w-full flex justify-center xs:px-6 sm:px-8 sm:py-1 lg:px-10 lg:py-1 rounded-full cursor-pointer"
                          type="submit"
                          disabled={isLoading}
                        >
                          {isLoading ? (
                            <div className="flex justify-center items-center">
                              <div className="animate-spin rounded-full border-t-2 border-b-2 group-hover:border-primary border-secondary w-6 h-6"></div>
                            </div>
                          ) : (
                            <p className="xs:text-[10px] sm:text-xs lg:text-sm xl:text-base font-onestRegular text-secondary">
                              Apply
                            </p>
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
